import request from '../utils/http'
// 列表（管理员）
export function index (query) {
  return request({
    url: '/account/index?limit=500',
    method: 'GET',
    params: query
  })
}
// 详情
export function edit (query) {
  return request({
    url: '/account/edit',
    method: 'GET',
    params: query
  })
}
// 新增
export function save (query) {
  return request({
    url: '/account/save',
    method: 'POST',
    data: query
  })
}
// 更新
export function update (query) {
  return request({
    url: '/account/update',
    method: 'POST',
    data: query
  })
}
// 改密
export function resetPassword (query) {
  return request({
    url: '/resetPassword',
    method: 'POST',
    data: query
  })
}
// 开关
export function show (query) {
  return request({
    url: '/account/show',
    method: 'POST',
    data: query
  })
}
// 删除
export function del (query) {
  return request({
    url: '/account/delete',
    method: 'DELETE',
    data: query
  })
}
// 检测账号 （未用上）
export function checkAccount (query) {
  return request({
    url: '/account/checkAccount',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/account.js